<mat-card class="card">
  <mat-card-content>
    <mat-progress-bar
      *ngIf="isFormLoading"
      mode="indeterminate"
    ></mat-progress-bar>

    <form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
      <ix-fieldset [title]="'Resilver Priority' | translate">
        <ix-checkbox
          formControlName="enabled"
          [label]="'Enabled' | translate"
          [tooltip]="tooltips.enabled"
        ></ix-checkbox>

        <ix-select
          formControlName="begin"
          [label]="'Begin' | translate"
          [options]="timeOptions$"
          [tooltip]="tooltips.begin"
        ></ix-select>

        <ix-select
          formControlName="end"
          [label]="'End' | translate"
          [options]="timeOptions$"
          [tooltip]="tooltips.end"
        ></ix-select>

        <ix-select
          formControlName="weekday"
          [label]="'Days of the Week' | translate"
          [options]="daysOfWeek$"
          [tooltip]="tooltips.weekday"
          [multiple]="true"
          [required]="true"
        ></ix-select>
      </ix-fieldset>

      <div class="form-actions">
        <button
          *ixRequiresRoles="requiredRoles"
          mat-button
          type="submit"
          color="primary"
          ixTest="save"
          [disabled]="form.invalid || isFormLoading"
        >
          {{ 'Save' | translate }}
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
